import { render } from "./CenterTemplate.vue?vue&type=template&id=04705cd0"
import script from "./CenterTemplate.vue?vue&type=script&lang=js"
export * from "./CenterTemplate.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__